export default __webpack_public_path__ + "static/media/kamivest_logo_center_white.94076a6f.svg";